import styled from "styled-components";
import {
  CARD_BACKGROUND,
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  FONTS,
} from "../../../../constants/Styles";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5rem;
  align-items: center;
  justify-content: center;
  max-width: 100vw;
  padding: 2rem;
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5rem;
  justify-content: space-around;
`;

export const LinksContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: space-evenly;
`;

export const ActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  ${CARD_BACKGROUND};
  border: 1px solid ${COLORS.tableBackground};
  border-radius: 1.5rem;
  padding: 2rem;
  min-width: 24rem;
`;

export const PartCheckInContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const PartCheckInRowContainer = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const SectionContainer = styled.div`
  flex: 1;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
`;

export const BoardPartOptionsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  overflow-y: scroll;
  gap: 1rem;
`;

export const SelectBinContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: flex-end;
`;

export const BoardPartOptionDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const BoardPartOption = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  gap: 0.5rem;
  ${CARD_BACKGROUND};
  border-radius: 0.5rem;
  &:hover {
    background-color: ${COLORS.badgeGray};
  }
  cursor: pointer;
`;

export const Title = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size24};
  flex: 1;
`;

export const StepTitle = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size18};
`;

export const PartDrawerInventorySubTitle = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size18};
  width: 100%;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const SubTitle = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size18};
  width: 100%;
  text-align: center;
`;

export const Detail = styled.div`
  color: ${COLORS.secondaryLight};
  font-weight: ${FONT_WEIGHT.weight400};
`;

export const InventoryFormTitle = styled.div`
  font-family: ${FONTS.spaceGrotesk};
  font-size: ${FONT_SIZE.size18};
`;

export const ButtonsRow = styled.div`
  display: flex;
  gap: 1rem;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  width: 100%;
`;

export const ContainerDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: flex-start;
  width: 100%;
`;

export const ChildrenGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  width: 100%;
`;

export const ImageContainer = styled.div`
  height: 9rem;
`;

export const BarcodeScannerSetupImage = styled.img`
  max-width: 20rem;
`;

export const BoardsNeedingPartContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const InventoryItemFormContainer = styled.div`
  min-width: 40rem;
`;

export const QtyFieldContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;
